import { configureStore } from "@reduxjs/toolkit";

import auth from "../slices/authSlice";
import course from "../slices/courseSlice";
import studyPlanner from "../slices/studyPlannerSlice";
import quiz from "../slices/quizSlice";
import dashboard from "../slices/dashBoadrdSlice";
import payment from "../slices/paymentSlice";
import learningHub from "../slices/learningHubSlice";

const store = configureStore({
    reducer: {
        auth: auth,
        course: course,
        studyPlanner: studyPlanner,
        quiz: quiz,
        dashboard: dashboard,
        payment: payment,
        learningHub: learningHub,
    },
});

export default store;
